const strings = {};

export default strings;
